import { render, staticRenderFns } from "./EditorMediosGaleria.vue?vue&type=template&id=0b96b69f&scoped=true"
import script from "./EditorMediosGaleria.vue?vue&type=script&lang=js"
export * from "./EditorMediosGaleria.vue?vue&type=script&lang=js"
import style0 from "./EditorMediosGaleria.vue?vue&type=style&index=0&id=0b96b69f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b96b69f",
  null
  
)

export default component.exports